export function AggregateFunction(id, name, title, sqlName, description, appliesTo, returnType, returnsDecimal, returnsPercentage)
{
    this.id = id;
    this.name = name;
    this.title = title;
    this.sqlName = sqlName;
    this.description = description;
    this.appliesTo = appliesTo;
    this.returnType = returnType;
    this.returnsDecimal = returnsDecimal;
    this.returnsPercentage = returnsPercentage;
}

AggregateFunction.functions = [
    new AggregateFunction(1, "Count", "Count", "COUNT", "", 0, 2, false, false),
    new AggregateFunction(2, "Count Distinct", "Count Distinct", "COUNT DISTINCT", "", 0, 2, false, false) ,
    new AggregateFunction(3, "Minimum", "Minimum", "MIN", "", 25, 0, null, null) ,
    new AggregateFunction(4, "Maximum", "Maximum", "MAX", "", 25, 0, null, null) ,
    new AggregateFunction(5, "Sum", "Sum", "SUM", "", 2, 2, null, null) ,
    new AggregateFunction(6, "Average", "Average", "AVG", "", 2, 2, true, null) ,
    new AggregateFunction(7, "Standard Dev.", "Standard Dev.", "STDEV", "", 2, 2, true, false) ,
    new AggregateFunction(8, "Standard Dev. Distinct", "Standard Dev. Distinct", "STDEV DISTINCT", "", 2, 2, true, false) ,
    new AggregateFunction(9, "Standard Dev. Pop.", "Standard Dev. Pop.", "STDEVP", "", 2, 2, true, false) ,
    new AggregateFunction(10, "Standard Dev. Pop. Distinct", "Standard Dev. Pop. Distinct", "STDEVP DISTINCT", "", 2, 2, true, false)
];

AggregateFunction.where = function(predicate)
{
    let result = [];

    if(!predicate)
       return result;

    for(let entry in AggregateFunction.functions)
    {
        if(predicate(AggregateFunction.functions[entry]))
           result.push(new AggregateFunction(entry.id, entry.name, entry.title, entry.sqlName, entry.description, entry.appliesTo, entry.returnType, entry.returnsDecimal, entry.returnsPercentage));
    }

    return result;
};

AggregateFunction.isValidFunction = function(id)
{
    return AggregateFunction.functions.find(e => e.id == id);
};

AggregateFunction.getById = function(id)
{
    let entry = AggregateFunction.functions.find(e => e.id == id);
    if(entry)
        return new AggregateFunction(entry.id, entry.name, entry.title, entry.sqlName, entry.description, entry.appliesTo, entry.returnType, entry.returnsDecimal, entry.returnsPercentage);
    
    return null;
};

AggregateFunction.prototype.getReturnTypeFromField = function(fieldType)
{
    return this.returnType === 2 ? 2 : fieldType;
};

AggregateFunction.prototype.returnsDecimalFromFieldType = function(fieldIsDecimal)
{
    return (this.returnsDecimal === true || this.returnsDecimal === false) ? this.returnsDecimal : fieldIsDecimal
};

AggregateFunction.prototype.returnsPercentageFromFieldType = function(fieldIsPercentage)
{
    return (this.returnsPercentage === true || this.returnsPercentage === false) ? this.returnsPercentage : fieldIsPercentage
};


AggregateFunction.prototype.appliesToDataType = function(dataTypeId)
{
    if (dataTypeId < 1 || dataTypeId > 5)
        return false;

    if (this.appliesTo == 0)
        return true;

    if (dataTypeId == this.appliesTo)
        return true;

    if (this.appliesTo == 25 && (dataTypeId == 2 || dataTypeId == 4 || dataTypeId == 5))
        return true;

    return false;
};